import { lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import '@bluecodecom/fonts';

import { LoaderProvider } from '@bluecodecom/loader';

import './i18n';
import './styles.css';

const App = lazy(() => import('./app'));

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <LoaderProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </LoaderProvider>,
);
